export default __webpack_public_path__ + "static/media/viewtofront1.fe4a0393.jpg";